import { render, staticRenderFns } from "./order_timeline_status.vue?vue&type=template&id=3136dd05&scoped=true&"
import script from "./order_timeline_status.vue?vue&type=script&lang=js&"
export * from "./order_timeline_status.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3136dd05",
  null
  
)

export default component.exports